/**
 * The file enables `@/store/index.js` to import all vuex modules
 * in a one-shot manner. There should not be any reason to edit this file.
 */
// https://webpack.docschina.org/guides/dependency-management/#require-context
// 实现去中心化管理 正则匹配引入相应的文件模块
/*
*require.context 有三个参数：
*
*directory：说明需要检索的目录
*useSubdirectories：是否检索子目录
*regExp: 匹配文件的正则表达式
*
*/
const files = require.context('./modules', false, /\.js$/)
const modules = {}
files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default {
  namespaced: true,
  modules
}
